'use client';

import type { ForwardRefComponent } from '@fluentui/react-utilities';

import { useTagPickerButton } from './useTagPickerButton';
import { renderTagPickerButton } from './renderTagPickerButton';
import type { TagPickerButtonProps } from './TagPickerButton.types';
import { composeComponent } from '../../../utils/composeComponent';

/**
 * A button trigger for a TagPicker, used as an alternative to `TagPickerInput` when the
 * picker does not need free-text filtering.
 */
export const TagPickerButton: ForwardRefComponent<TagPickerButtonProps> = /*#__PURE__*/ composeComponent(
  'TagPickerButton',
  useTagPickerButton,
  renderTagPickerButton,
);
